import whenDomReady from "when-dom-ready";
import renderFromPreloadedJSON from "~/common/renderFromPreloadedJSON";
import LeadGenerationPage from ".";

whenDomReady(() => {
  if (
    document.querySelector(
      '[data-hypernova-key="PageCreatorLeadGenerationPage"]',
    )
  ) {
    renderFromPreloadedJSON(
      LeadGenerationPage,
      "PageCreatorLeadGenerationPage",
    );
  }
});
